import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_contact_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  first_name: fromDatatype.VarcharDatatypeInterface;
  last_name: fromDatatype.VarcharDatatypeInterface;
  full_name: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  job_description: fromDatatype.VarcharDatatypeInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  mobile: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  is_blocked: boolean;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_sfa_contact_hdr_RowClass
  implements bl_sfa_contact_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  first_name: fromDatatype.VarcharDatatypeInterface;
  last_name: fromDatatype.VarcharDatatypeInterface;
  full_name: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  job_description: fromDatatype.VarcharDatatypeInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  mobile: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  is_blocked: boolean;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
